"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ModalActions extends _react.default.Component {
  renderSecondary() {
    const {
      props
    } = this;

    if (!props.primaryAction || !props.secondaryAction) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-child-no-shrink mr12"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: "discouraging",
      size: "medium",
      onClick: props.secondaryAction.callback,
      "data-test": "secondary-modal-action",
      passthroughProps: {
        'aria-label': props.secondaryAction.text
      }
    }, props.secondaryAction.text));
  }

  renderTertiary() {
    const {
      props
    } = this;

    if (!props.primaryAction || !props.secondaryAction || !props.tertiaryAction) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-child-grow flex-child-no-shrink mr12"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": props.tertiaryAction.text,
      type: "button",
      className: "link link--gray txt-bold txt-s",
      onClick: props.tertiaryAction.callback,
      "data-test": "tertiary-modal-action"
    }, props.tertiaryAction.text));
  }

  render() {
    const {
      props
    } = this;
    const primaryButtonVariant = props.primaryAction.destructive ? 'destructive' : 'primary';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex--center-main flex--center-cross flex--row-reverse flex--wrap"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-child-no-shrink"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: primaryButtonVariant,
      size: "medium",
      onClick: props.primaryAction.callback,
      "data-test": "primary-modal-action",
      passthroughProps: {
        'aria-label': props.primaryAction.text
      }
    }, props.primaryAction.text)), this.renderSecondary(), this.renderTertiary());
  }

}

exports.default = ModalActions;
ModalActions.propTypes = {
  primaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired,
    destructive: _propTypes.default.bool
  }).isRequired,
  secondaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired
  }),
  tertiaryAction: _propTypes.default.shape({
    text: _propTypes.default.string.isRequired,
    callback: _propTypes.default.func.isRequired
  })
};